import React from "react";
import { useHistory, useParams, Redirect } from "react-router-dom";
import { useQuery } from "react-query";
import { Flex } from "@chakra-ui/layout";
import { Spinner } from "@chakra-ui/spinner";
import useErrorToast from "hook/error-toast";
import { useAppSelector } from "app/hook";

import { fetchQuestionById } from "API/questionApi";

// Update forms
import UpdateQuestionLA from "./UpdateQuestionLA";
import UpdateQuestionMCQM from "./UpdateQuestionMCQM";
import UpdateQuestionMCQS from "./UpdateQuestionMCQS";
import UpdateQuestionTF from "./UpdateQuestionTF";
import UpdateQuestionLong from "./UpdateQuestionLong";
import UpdateQuestionShort from "./UpdateQuestionShort";
import UpdateQuestionDiagram from "./UpdateQuestionDiagram";

const UpdateQuestion = () => {
  const { type, id } = useParams<{ type: string; id: string }>();
  const { role } = useAppSelector((state) => state.auth);
  const history = useHistory();


  if (!type || !id) {
    return <Redirect to={`/${role || "admin"}/dashboard`} />;
  }

  const {
    data,
    isLoading,
    error,
  } = useQuery(["question", id, type], () => fetchQuestionById(id, type), {

  });

  useErrorToast(error);

  if (isLoading) {
    return (
      <Flex justify="center" align="center" minH="200px">
        <Spinner />
      </Flex>
    );
  }


  if (!data) {
    return <Redirect to={`/${role || "admin"}/dashboard/questions`} />;
  }

  switch (type.toLowerCase()) {
    case "tf":
      return <UpdateQuestionTF role={role} question={data} />;

    case "mcqs":
      return <UpdateQuestionMCQS role={role} question={data} />;

    case "mcqm":
      return <UpdateQuestionMCQM role={role} question={data} />;

    case "la":
      return <UpdateQuestionLA role={role} question={data} />;

    // AIEdge
    case "long":
      return <UpdateQuestionLong role={role} question={data} />;

    case "short":
      return <UpdateQuestionShort role={role} question={data} />;

    case "diagram":

      return <UpdateQuestionDiagram role={role} question={data} />;

    default:
      return <Redirect to={`/${role || "admin"}/dashboard`} />;
  }
};

export default UpdateQuestion;
